<template>
  <v-content class="mt-7 ml-7 mr-7">
     
    <v-container grid-list-md class="pb-0" style="background-color:#FFFFFF">
             <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        sort-by="calories"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Catálogo Unidades</v-toolbar-title>

            <!-- <v-divider class="mx-3" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Agregar Unidad</v-btn>
              </template>
              <v-card>
                <v-window v-model="step">
                  <v-window-item :value="1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md4>
                            <v-text-field v-model="editedItem.siglas" label="Sin Siglas"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md12>
                            <v-text-field
                              v-model="editedItem.nombreUnidad"
                              label="Nombre de la Unidad"
                            ></v-text-field>
                          </v-flex>
                          <v-card-actions xs12 sm3 lg4 text-sm-right>
                            <v-list-item>
                              <v-list>
                                <v-layout wrap>
                                  <v-card-actions xs12 sm3 lg4 text-sm-right>
                                    <div id="demo" :style="styleHeader">
                                      <v-icon size="35" color="white">{{ editedItem.icono }}</v-icon>
                                    </div>
                                    <v-list-item-title v-if="$dayspan.supports.color">
                                      <v-list-item-content>
                                        <slot
                                          name="eventDetailsColor"
                                          v-bind="slotData"
                                          :style="styleHeader"
                                        >
                                          <!-- prepend-icon="feedback" -->
                                          <v-select
                                            single-line
                                            hide-details
                                            solo
                                            flat
                                            :items="$dayspan.colors"
                                            :color="editedItem.color"
                                            v-model="editedItem.color"
                                          >
                                            <template slot="item" slot-scope="{ item }">
                                              <v-list-item-content>
                                                <div
                                                  class="ds-color-option"
                                                  :style="{backgroundColor: item.value}"
                                                  v-text="item.text"
                                                ></div>
                                              </v-list-item-content>
                                            </template>
                                          </v-select>
                                        </slot>
                                      </v-list-item-content>
                                    </v-list-item-title>
                                  </v-card-actions>
                                  <v-card-actions xs12 sm3 lg4 text-sm-right>
                                    <v-btn
                                      :style="styleHeader"
                                      class="ma-2"
                                      dark
                                      @click="dialogIcon = true"
                                    >Elige un icono</v-btn>
                                  </v-card-actions>
                                  <v-text v-model="editedItem.icono" :label="icon" hidden>"{{icon}}"</v-text>
                                </v-layout>
                              </v-list>

                              <!-- Termina DDL -->
                            </v-list-item>
                          </v-card-actions>
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                      <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
                    </v-card-actions>
                  </v-window-item>

                  <!--Inicia dialog de iconos  -->
                  <v-dialog v-model="dialogIcon" max-width="800px">
                    <v-card>
                      <v-card-title>
                        <span>Selecciona icono</span>
                        <div class="flex-grow-1"></div>
                        <v-layout align-center justify-center wrap>
                          <v-flex v-for="icon in icons" :key="icon.idIcono" ma-2>
                            <!-- prubas de guardado de boto n icono  -->
                            <v-btn icon v-on:click="di(icon.nombre)" @click="dialogIcon = false">
                              <v-icon>{{ icon.nombre }}</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-menu bottom left>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on">
                              <!-- <v-icon>mdi-dots-vertical</v-icon> -->
                            </v-btn>
                          </template>
                        </v-menu>
                      </v-card-title>
                    </v-card>
                  </v-dialog>
                  <!-- Termina dialogo de iconos -->
                </v-window>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
          <v-icon small @click="deleteItem(item)">delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getCatUnidad">Reset</v-btn>
        </template>
      </v-data-table>
    </v-container>
  </v-content>
</template>

<script>
// import axunidad from "axios";
// import { async } from 'q';
import { validationMixin } from "vuelidate";

import { axiosSingleton } from "@/plugins/axios";
import  fraccionServices  from "../services/FraccionService";

//let apiUrl = 'https://colmenac.ugto.mx/rg/Transparencia/'
//let apiUrl = 'https://localhost:44340/'
let apiUrl = 'https://enjambrec.ugto.mx/RG/Transparencia/'
export default {
  mixins: [],

  validations: {
    // name: { required, maxLength: maxLength(10) },
    // email: { required, email },
    // select: { required },
    // checkbox: {
    //   checked (val) {
    //     return val
    //   },
    // },
  },

  name: "DtUnidad",
  data: () => ({
    search: "",
    step: 1, // windows add
    dialogIcon: false,
    aguardado: [],
    icon: "",
    icono: "",

    dialog: false,
    headers: [
      { text: "Siglas", value: "siglas" },
      { text: "Nombre unidad", value: "nombreUnidad" },
      // { text: 'prop 2', value: 'prop2' },
      { text: "Acción", value: "action", sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0,

      colors: []
    },
    defaultItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0
    },
    //  details: { colors:[], // icons: []
    //  },
    //  formClasi: {
    //    icon: '',
    // },
    icons: []
  }),

  computed: {
    slotData() {
      return {
        details: this.details
      };
    },
    styleHeader() {
      return {
        backgroundColor: this.editedItem.color,
        color: this.editedItem.forecolor
      };
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Unidad" : "Editar Unidad";
    },
    currentTitle() {
      switch (this.step) {
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    let self = this;
    //  this.initialize();
    self.getCatUnidad();
    self.getIcon();
  },

  methods: {
    //di: function (mensaje) { return this.icon=mensaje},
    di: function(mensaje) {
      return (this.editedItem.icono = mensaje);
    },
    // caicon: function(){ this.editedItem.icono.push(this.nuevo); this.nuevo=""; },

    getCatUnidad() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
        .getCatUnidad()
        .then(r => {
          this.desserts = r.data.data;
        })
        .catch(error => console.error("Error:", error))
        .then(response => console.log("Success:", response));
    },

    getIcon() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
        .getIcon()
        .then(r => {
          this.icons = r.data.data;

          //console.log(this.icons);
          //console.log(this.icons.nombre);
        })
        .catch(error => console.error("Error:", error))
        .then(response => console.log("Success:", response));
    },
    async editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // console.log(this.editedItem);
      this.dialog = true;
    },

    deleteItem(item) {
      let self = this;
      var txt;
      const index = this.desserts.indexOf(item);
      //  console.log(item);
      var r = confirm("Borrar Unidad?") && this.desserts.splice(index, 1);
      // console.log(r);
      if (r.length == 1) {
        let self = this;
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.removeUnidad(item.idUnidad);
      } else {
        console.log("cancelar");
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      let self = this;
      if (this.editedIndex > -1) {
        //Editar Unidad
        console.log("Actualizar Unidad", this.editedItem);
        let self = this;
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
          .updateUnidad(self.editedItem)
          .then(r => {
            r.data;
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));

        //  console.log(data);
      } else {
        //Guardar Unidad
        console.log("pr guardar icono", this.editedItem.icono);
        var unidad = {
          color: this.editedItem.color,
          siglas: this.editedItem.siglas,
          nombreUnidad: this.editedItem.nombreUnidad,
          icono: this.editedItem.icono
        };
        console.log(unidad);
        this.desserts.push(this.editedItem);
        let self = this;

        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
          .addUnidad(self.editedItem)
          .then(r => {
            self.getCatUnidad();
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));
      }
      this.close();
    },
    async fraccionadd(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // console.log(this.editedItem);
      this.dialog = true;
    }
  }
};
</script>

